import React, { useEffect, useState } from "react";
import { Provider as ReduxProvider } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import userLanguage from "languages/english.json";
import withToasts from "hoc/withToasts";
import VmErrorScreen from "components/VmErrorScreen/VmErrorScreen";
import reduxStore from "store/store";
import {
  getVendingMachineUuid,
  initFetchInterceptor,
  pageUrlHasUuid,
  preventReloadPage,
  setVendingMachineUuid,
} from "utils/commonMethods";
import { APP_ROUTES } from "constants/routes";
import { requestPostFetchApi } from "utils/apiMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { GET_VM_POLLING_TIME } from "constants/constants";

window.appTexts = userLanguage;

function GateKeeper({ showErrorToast }) {
  const [vmIsOffline, setVmIsOffline] = useState(false);
  //Disable vendify loader.
  document.getElementById("app-loader").style.display = "none";

  //Validations for vm is offline
  const handleVmIsOffline = function () {
    requestPostFetchApi(API_KEYS.GET_VM_DETAILS, {
      uuid: getVendingMachineUuid(),
    }).then((response) => {
      //VM not found
      if (!response.vendingMachine) {
        return;
      }

      return setVmIsOffline(!response.vendingMachine.is_online);
    });
  };

  useEffect(() => {
    //Api polling for get vm details
    handleVmIsOffline();
    //Polling
    setInterval(() => {
      handleVmIsOffline();
    }, GET_VM_POLLING_TIME);
    preventReloadPage();
  }, []);

  //Handles vending machine uuid throughout the application.
  //If url doesn't have vending machine uid, alert user
  if (!getVendingMachineUuid() && !pageUrlHasUuid()) {
    return (
      <VmErrorScreen
        errorMessages={window.appTexts.error_no_vending_machine_id_found}
      />
    );
  } else if (pageUrlHasUuid()) {
    //Removes '/' from first place.
    setVendingMachineUuid(window.location.pathname.substr(1));

    //Reload the page if vending machine not found in localStorage
    if (!getVendingMachineUuid()) {
      window.location.reload();
    }
  }

  // Interceptor for fetch
  initFetchInterceptor(showErrorToast);

  return (
    <Router>
      <ReduxProvider store={reduxStore}>
        <Switch>
          {vmIsOffline ? (
            <VmErrorScreen
              errorMessages={window.appTexts.error_vending_machine_is_offline}
            />
          ) : (
            Object.values(APP_ROUTES).map((route) => (
              <Route
                path={route.url}
                component={route.component}
                key={route.url}
                exact
              />
            ))
          )}
          <Redirect to={APP_ROUTES.HOME_PAGE.url} />
        </Switch>
      </ReduxProvider>
    </Router>
  );
}

export default withToasts(GateKeeper);
